import React from "react"
import { Layout } from "../components/Layout"
import { Fade } from "reactstrap"
import { GalleryComponent } from "../components/Gallery"
import { Timeline } from "rsuite"
import moment from "moment"

const events = [
  { ts: "2020-10-27T00:31:00.007Z", text: "ยกขันหมาก" },
  { ts: "2020-10-27T01:30:00.007Z", text: "แห่ขันหมาก" },
  { ts: "2020-10-27T01:50:00.007Z", text: "พิธีพระ" },
  { ts: "2020-10-27T03:00:00.007Z", text: "พิธีหมั้น" },
  { ts: "2020-10-27T03:30:00.007Z", text: "ยกน้ำชา" },
  { ts: "2020-10-27T04:00:00.007Z", text: "รดน้ำสังข์" },
  { ts: "2020-10-27T10:00:00.007Z", text: "งานเลี้ยงแต่งงาน" },
]

const IndexPage = () => {
  if (typeof window !== "undefined") {
    return (
      <Layout>
        <div className="header-container">
          <Fade>
            <div className="text save-date text-bold">
              SAVE&nbsp;&nbsp;THE&nbsp;&nbsp;DATE
            </div>
          </Fade>
          <Fade>
            <div className="text date">
              <div className="text-wrap">
                <span className="text-bold text-red">27</span>
                <span>&nbsp;{`October 2020`}</span>
              </div>
            </div>
          </Fade>
        </div>
        <div className="gallery-container">
          <div className="text-title">Gallery</div>
          <GalleryComponent />
        </div>
        <div className="carlendar-container">
          <div className="text-title mb-4">กำหนดการ</div>
          <Timeline>
            {events.map(item => {
              return (
                <Timeline.Item>
                  {moment(item.ts).format("HH:mm")} {item.text}
                </Timeline.Item>
              )
            })}
          </Timeline>
        </div>
        <div className="location-container">
          <Fade>
            <a
              href="https://www.google.com/maps/dir//%E0%B9%80%E0%B8%A3%E0%B8%B7%E0%B8%AD%E0%B8%99%E0%B8%8A%E0%B9%89%E0%B8%B2%E0%B8%87%E0%B8%99%E0%B8%AD%E0%B8%99+%E0%B8%95%E0%B8%B3%E0%B8%9A%E0%B8%A5+%E0%B8%A5%E0%B8%B3%E0%B8%A0%E0%B8%B5+%E0%B8%AD%E0%B8%B3%E0%B9%80%E0%B8%A0%E0%B8%AD+%E0%B8%97%E0%B9%89%E0%B8%B2%E0%B8%A2%E0%B9%80%E0%B8%AB%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%87+%E0%B8%9E%E0%B8%B1%E0%B8%87%E0%B8%87%E0%B8%B2+82120/@8.595039,98.3472624,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3050e5192ad39a9b:0x29f89ec039c2483e!2m2!1d98.3471649!2d8.5943399"
              target="_blank"
              rel="noreferrer"
            >
              <div className="content-wrap">
                <div className="icon">
                  <img
                    src="/icons/google_map.png"
                    alt="google map"
                    className="image"
                  />
                </div>
                <div className="text text-black text-center mt-4">
                  เรือนช้างนอน
                </div>
                <div className="text text-16 text-black mt-1">
                  ตำบล ลำภี อำเภอ ท้ายเหมือง พังงา 82120
                </div>
              </div>
            </a>
          </Fade>
        </div>
        <div className="contact-container">
          <Fade>
            <a href="tel:0898725463" target="_blank" rel="noreferrer">
              <div className="content-wrap">
                <div className="icon">
                  <img
                    src="/icons/phone.png"
                    alt="google map"
                    className="image"
                  />
                </div>
                <div className="text text-black text-center mt-4">
                  ติดต่อสอบถาม
                </div>
                <div className="text text-16 text-black mt-1">
                  (+66) 089-872-5463
                </div>
              </div>
            </a>
          </Fade>
        </div>
      </Layout>
    )
  }
  return null
}

export default IndexPage
